import { useInventoryEventDetailContext } from 'src/contexts/InventoryEventDetailContext/InventoryEventDetailContext';

import { NoteSectionV2 } from '../../../Sections/NoteSectionV2';

export const NotesDetailPanel = () => {
  const { event } = useInventoryEventDetailContext();
  return !event ? null : <NoteSectionV2 eventId={event.viagId} />;
};
